import { BOARD_PATHS } from 'data/constants';

// 전용 페이지가 없는 게시판의 목록 경로
export const genericBoardPath = (moduleNo) => `/community/board/${moduleNo}`;

// 게시판 번호 → 사이트 경로 (전용 페이지가 있으면 그 경로, 아니면 generic 경로)
export const boardPath = (moduleNo) => BOARD_PATHS[Number(moduleNo)] || genericBoardPath(moduleNo);

// 경로가 어떤 전용 게시판(1~5)의 경로인지 역조회
const moduleNoByPath = (path) => {
  const found = Object.keys(BOARD_PATHS).find((moduleNo) => BOARD_PATHS[moduleNo] === path);
  return found ? Number(found) : null;
};

/**
 * 관리자에 등록된 게시판 목록으로 커뮤니티 하위 메뉴를 만든다.
 * - 기존 전용 게시판(공지/견적문의/FAQ/Q&A/자료실)은 정적 메뉴 순서를 유지하되, DB 에 없으면(use_yn=0/삭제) 제외
 * - 그 외 게시판은 module_no 오름차순으로 뒤에 추가 (generic 경로)
 * - useDbTitle=true(한국어)면 라벨을 DB moduleTitle 로, false(영어)면 기존 정적 라벨 유지 (새 게시판은 moduleTitle 그대로)
 * - boards 가 없으면(조회 실패) 정적 메뉴를 그대로 반환
 */
export function buildCommunitySub(staticSub, boards, useDbTitle = true) {
  if (!Array.isArray(boards)) {
    return staticSub;
  }

  const byNo = {};
  boards.forEach((board) => {
    byNo[Number(board.moduleNo)] = board;
  });

  const known = [];
  const usedNos = new Set();
  staticSub.forEach((item) => {
    const moduleNo = moduleNoByPath(item.path);
    if (moduleNo === null) {
      known.push(item);
      return;
    }
    const board = byNo[moduleNo];
    if (!board) {
      return;
    }
    usedNos.add(moduleNo);
    known.push({
      ...item,
      moduleNo,
      name: (useDbTitle && board.moduleTitle) || item.name,
    });
  });

  const others = boards
    .filter((board) => !usedNos.has(Number(board.moduleNo)) && !BOARD_PATHS[Number(board.moduleNo)])
    .sort((a, b) => Number(a.moduleNo) - Number(b.moduleNo))
    .map((board) => ({
      name: board.moduleTitle,
      path: genericBoardPath(board.moduleNo),
      moduleNo: Number(board.moduleNo),
    }));

  return [...known, ...others];
}

// langList(krLang/enLang) 의 nav 에서 커뮤니티 항목의 sub 만 DB 기준으로 교체한 새 langList 반환
export function applyBoardsToLang(langList, boards, useDbTitle = true) {
  if (!langList || !Array.isArray(langList.nav) || !Array.isArray(boards)) {
    return langList;
  }

  const nav = langList.nav.map((item) => {
    if (!item.path || !item.path.includes('/community')) {
      return item;
    }
    const sub = buildCommunitySub(item.sub || [], boards, useDbTitle);
    // 하위 메뉴가 비면 정적 메뉴 유지 (메뉴가 사라지지 않도록)
    return { ...item, sub: sub.length > 0 ? sub : item.sub };
  });

  return { ...langList, nav };
}
